<ul class="nav nav-tabs">
	{{#each tabs}}
	<li class="tab-heading {{#if active}} active {{/if}}"><a href="#{{../IDPrefix}}{{tabID}}" class="js-fb-tab" data-tab="{{tabID}}"  data-toggle="tab" aria-expanded="false">{{tabHeading}}</a></li>
	{{/each}}
</ul>

<div class="m-t-20"></div>
{{#each blocks}}
<div class="row">
    <div class="col-lg-6 col-md-9 col-sm-10">
        {{#unless ../readMode}}
        {{#if is_disabled}}<span class="text-muted">{{else}}<a href="#" class="js-fb-block" data-value="{{is_active}}" data-block="{{fb}}" data-group="{{group}}" >{{/if}}
        {{/unless}}
            {{#if is_active}}<strong>{{/if}}{{#if group}}{{group}} {{/if}}{{fb}}: {{TR name}}{{#if is_active}}</strong>{{/if}}
        {{#unless ../readMode}}
            {{#if is_disabled}}</span>{{else}}</a>{{/if}}
        {{/unless}}
    </div>
    <div class="col-lg-2 col-md-3 col-sm-2">
        {{#unless ../readMode}}
            {{#if is_disabled}}<span class="text-muted">{{else}}<a href="#" class="js-fb-block" data-value="{{is_active}}" data-block="{{fb}}" data-group="{{group}}" >{{/if}}
        {{/unless}}
            {{#if is_active}}<strong>{{TR "AKTIV"}}</strong>{{else}}{{TR "INAKTIV"}}{{/if}}
        {{#unless ../readMode}}
            {{#if is_disabled}}</span>{{else}}</a>{{/if}}
        {{/unless}}
    </div>
</div>
{{/each}}

{{#unless blocks}}
{{#if error}}
    <div class="alert alert-danger">{{TR "Die Funktionsblöcke konnten nicht gelesen werden."}}</div>
{{else}}
{{#unless loading}}
    <div class="alert alert-info">{{TR "Zurzeit sind keine Funktionsblöcke aktiv."}}</div>
{{/unless}}
{{/if}}
{{/unless}}
